export default __webpack_public_path__ + "static/media/apphub.06c406ac.svg";